import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { AsyncSelect } from "../../../../Input/Select";
import { jsx as _jsx } from "react/jsx-runtime";
function AsyncSelectCell(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(AsyncSelect, _extends({}, props));
}
export default AsyncSelectCell;